import React from "react";

export default function Legal() {
  const certificates = [
    {
      title: "Registration Certificate",
      number: "U47710PN2025PTC245022",
      img: "/incorporation_certificate.jpg",
    },
    {
      title: "PAN Card",
      number: "AATCM7158F",
      img: "/pan_card.jpg",
    },
    {
      title: "TAN Certificate",
      number: "PNEM45376C",
      img: "/tan.jpg",
    },
  ];

  return (
    <div className="min-h-screen bg-gray-100 p-6 flex flex-col items-center">
      <h1 className="text-4xl font-bold text-gray-800 mb-6">
        Legal & Certificates
      </h1>

      <p className="text-gray-600 mb-10 text-center max-w-2xl">
        All our legal documents and certificates are displayed here for
        verification.
      </p>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8 w-full max-w-6xl">
        {certificates.map((c, index) => (
          <div
            key={index}
            className="bg-white rounded-xl shadow-lg overflow-hidden border border-gray-200"
          >
            <img
              src={c.img}
              alt={c.title}
              className="w-full h-84 object-contain bg-gray-50 p-4"
            />

            <div className="p-4 text-center">
              <h2 className="text-xl font-semibold text-red-800">
                {c.title}
              </h2>
              <p className="text-black mt-1">No - {c.number}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
